import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {ServiceFormulaScheme, ServiceFormulaSchemeInput} from './service-formula-scheme.model';

export const loadServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] Load ServiceFormulaSchemes',
  props<{ serviceFormulaSchemes: ServiceFormulaScheme[] }>()
);

export const addServiceFormulaScheme = createAction(
  '[ServiceFormulaScheme/API] Add ServiceFormulaScheme',
  props<{ serviceFormulaScheme: ServiceFormulaScheme }>()
);

export const upsertServiceFormulaScheme = createAction(
  '[ServiceFormulaScheme/API] Upsert ServiceFormulaScheme',
  props<{ serviceFormulaScheme: ServiceFormulaScheme }>()
);

export const addServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] Add ServiceFormulaSchemes',
  props<{ serviceFormulaSchemes: ServiceFormulaScheme[] }>()
);

export const upsertServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] Upsert ServiceFormulaSchemes',
  props<{ serviceFormulaSchemes: ServiceFormulaScheme[] }>()
);

export const updateServiceFormulaScheme = createAction(
  '[ServiceFormulaScheme/API] Update ServiceFormulaScheme',
  props<{ serviceFormulaScheme: Update<ServiceFormulaScheme> }>()
);

export const updateServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] Update ServiceFormulaSchemes',
  props<{ serviceFormulaSchemes: Update<ServiceFormulaScheme>[] }>()
);

export const deleteServiceFormulaScheme = createAction(
  '[ServiceFormulaScheme/API] Delete ServiceFormulaScheme',
  props<{ id: string }>()
);

export const deleteServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] Delete ServiceFormulaSchemes',
  props<{ ids: string[] }>()
);

export const clearServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] Clear ServiceFormulaSchemes'
);

// CUSTOM
export const createServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] create ServiceFormulaSchemes',
  props<{ input: ServiceFormulaSchemeInput }>()
);


export const editServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] edit ServiceFormulaSchemes',
  props<{ input: ServiceFormulaSchemeInput }>()
);


export const getServiceFormulaSchemes = createAction(
  '[ServiceFormulaScheme/API] get all ServiceFormulaSchemes',
  props<{ billingUniqueId: string }>()
);

export const citizenGetInstitutionServiceFormulaBasedSchemes = createAction(
  '[ServiceFormulaScheme/API] citizen get all ServiceFormulaSchemes',
  props<{ billingUniqueId: string }>()
);
